/**
 * Shared visual helpers — pure functions, no React dependency.
 */

/**
 * Tailwind classes for a points badge based on points scored.
 *  - 5+ pts: green (great pick)
 *  - 1–4 pts: amber (partial credit)
 *  - 0 pts: muted grey
 */
export function pointsBadgeClass(points) {
    const n = Number(points) || 0;
    if (n >= 5) return "bg-[#00FF66]/20 text-[#00FF66]";
    if (n > 0) return "bg-[#FFB800]/15 text-[#FFB800]";
    return "bg-[var(--overlay-light)] text-[var(--text-secondary)]";
}
